export const isImageType = (kind: string) => kind.startsWith("image/") && kind !== "image/svg+xml";

export const isVideoType = (kind: string) => kind.startsWith("video/");

export const isAudioType = (kind: string) => kind.startsWith("audio/");

export const isPdfType = (kind: string) => kind === "application/pdf";

export const isMediaType = (kind: string) =>
  isImageType(kind) || isVideoType(kind) || isAudioType(kind) || isPdfType(kind);
